<div class="container-fluid">
  <div class="grid" style="padding-top:0.5rem">
    <mat-icon class="pageTitleIcon material-icons-outlined">library_books</mat-icon>
    <h2 class="pageTitleHeader">Artikeldaten</h2>

    @if (isLieferant()) {
      <i name="newarticledata" class="pi pi-plus pageAddButtonIcon"
      (click)="openArticleDataInsertDialog()" pTooltip="Artikeldaten erstellen"></i>
    }

  </div>




  <div class="contentSeperator"></div>
  @if (isLieferant() ) {
    <div class="row filterPanel grid">
      <div class="col-1">Filter:</div>
      <div class="col-2">
        <p-checkbox name="selectedFilters" value="0"  [(ngModel)]="selectedCategories"
        (onChange)="selectCategories('0')"></p-checkbox>
        <label class="ml-2">Alle</label>
      </div>
      <div class="col-2">
        <p-checkbox name="selectedFilters" value="200"  [(ngModel)]="selectedCategories"
        (onChange)="selectCategories('200')"></p-checkbox>
        <label class="ml-2">Neu</label>
      </div>
      <div class="col-2">
        <p-checkbox name="selectedFilters" value="300"  [(ngModel)]="selectedCategories"
        (onChange)="selectCategories('300')"></p-checkbox>
        <label class="ml-2">In Arbeit</label>
      </div>
      <div class="col-fixed" style="width: 10%">
        <p-checkbox name="selectedFilters" value="450"  [(ngModel)]="selectedCategories"
        (onChange)="selectCategories('450')"></p-checkbox>
        <label class="ml-2">Verschickt</label>
      </div>
    </div>
  } @else {
    <div class="row filterPanel grid">
      <div class="col-1">Filter:</div>
      <div class="col-2">
        <p-checkbox name="selectedFilters" value="1"  [(ngModel)]="selectedalleoderEigene"
        (onChange)="selectAlleoderEigene('1')"></p-checkbox>
        <label class="ml-2">Alle</label>
      </div>
      <div class="col-2">
        <p-checkbox name="selectedFilterseigene" value="0"  [(ngModel)]="selectedalleoderEigene"
        (onChange)="selectAlleoderEigene('0')"></p-checkbox>
        <label class="ml-2">Eigene</label>
      </div>
      <div class="col-fixed" style="width: 10%">
        <p-checkbox name="deletedManager" value="250"  [(ngModel)]="selectedCategories"
        (onChange)="selectCategories('250')"></p-checkbox>
        <label class="ml-2">Gelöschte</label>
      </div>
    </div>
  }
  <div class="contentSeperator"></div>
  <p-table [value]="articledata$ | async" [rows]="pageSorting.rowsToLoad" [paginator]="true" [pageLinks]="3"
    [lazy]="true" (onLazyLoad)="loadArticleData($event)" [totalRecords]="selectArticleHits$ | async"
    [first]="pageSorting.skipRows"
    [showGridlines]="true"
    [rowHover]="true"
    [stripedRows]="true"
    paginatorDropdownAppendTo="body"
    [rowsPerPageOptions]="[15,20,50,100]" [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'{first} bis {last} von {totalRecords} Aufgaben'">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5%"></th>
        <th style="width: 5%"></th>

        <th style="width: 5%"></th>
        <th style="width: 30%">Name</th>
        <th style="width: 10%"> {{isManager ? 'Erhalten' : 'Aktualisiert' }} </th>
        <th style="width: 25%">Listentyp</th>
        @if (!isLieferant()) {
          <th style="width: 15%">Lieferant</th>
        }
        <th style="width: 15%">EmpfängerIn</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td [ngClass]="'kb-cell'" style="width: 5%; padding-right: 0.5rem;">
          <p-button  type="button" icon="pi pi-search" severity="info" size=""
            (click)='openArticledataInfo(rowData)' [pTooltip]="getInfotooltip(rowData)" tooltipPosition="top"
          showDelay="1000" hideDelay="1000"></p-button>
        </td>
        <td [ngClass]="'kb-cell'" style="width: 5%; padding-right: 0.5rem;">
          @if (rowData.selectedValidationId && rowData.taskState <= 300 && !rowData.isReadOnly) {
            <p-button
              type="button" icon="pi pi-paperclip" severity="info" size="" (click)='openUpload(rowData)'
            [pTooltip]="getTooltipUploadEdit(rowData)" tooltipPosition="top" showDelay="1000" hideDelay="1000"></p-button>
          }
          @if (rowData.selectedValidationId && (rowData.taskState > 300 || rowData.taskState == 250 ) ) {
            <p-button size=""
              type="button" [icon]="getIconUpload(rowData)" [class]="getUploadClass(rowData)"
              (click)='openUpload(rowData)' [pTooltip]="getUploadtooltip(rowData)" tooltipPosition="top" showDelay="1000"
            hideDelay="1000"></p-button>
          }
        </td>

        <td [ngClass]="'kb-cell'" style="width: 5%">

          @if (canDelete(rowData)) {
            <p-button  type="button" icon="pi pi-trash"
              severity="warn" size=""
              (click)="deleteArticleData(rowData.id)" pTooltip="Artikeldaten löschen" tooltipPosition="top"
            showDelay="1000" hideDelay="1000"></p-button>
          }

          @if (canReaktivieren(rowData) ) {
            <p-button  type="button" icon="pi pi-replay" severity="info"
              size=""
              (click)="reactivateArticleData(rowData.id)" pTooltip="Artikeldaten reaktivieren" tooltipPosition="top"
            showDelay="1000" hideDelay="1000"></p-button>
          }

        </td>

        <td [ngClass]="'kb-cell'" style="width: 30%"><span [style]="getNotificationStyle(rowData) | async"> {{
        rowData.name }}</span></td>

        <td [ngClass]="'kb-cell'" style="width: 10%">{{ (isManager ? rowData.articledatatransfered :
        rowData.articledatachange) | date }}</td>
        <td [ngClass]="'kb-cell'" style="width: 25%">{{ rowData.selectedValidation
        }}</td>
        @if (!isLieferant()) {
          <td [ngClass]="'kb-cell'" style="width: 15%"> {{ getLieferantName(rowData) | async }}
          </td>
        }
        <td [ngClass]="'kb-cell'" style="width: 15%"> {{ getManagerName(rowData) | async }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>


<p-confirmDialog header="Bitte bestätigen:" icon="pi pi-exclamation-triangle" message="Keine Zeilen werden gelöscht."
rejectLabel="Abbrechen"></p-confirmDialog>
